import { defineMessages } from 'react-intl';

export default defineMessages({
  pageExpired: {
    id: 'globalUserMessage.pageExpired',
    defaultMessage: 'We are updating your order. Wait a moment.',
  },
  productNotExist: {
    id: 'globalUserMessage.productNotExist',
    defaultMessage: 'Could not find the product. Try product search.',
  },
});
